import {
  Alert,
  Box,
  Button,
  InfoIcon,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@razorpay/blade/components';
import React from 'react';

interface VPFOptOutModalProps {
  isOpen: boolean;
  onDismiss: () => void;
  onOptOut: () => void;
}

const VPFOptOutModal: React.FC<VPFOptOutModalProps> = ({
  isOpen,
  onDismiss,
  onOptOut,
}) => {
  
  const handleOptOut = () => {
    onOptOut();
    onDismiss();
  };

  return (
    <Modal
      isOpen={isOpen}
      onDismiss={onDismiss}
      size="small"
      accessibilityLabel="Confirm Opt-Out from Voluntary Provident Fund (VPF)">
      <ModalHeader title="Confirm Opt-Out from VPF" />
      <ModalBody padding="spacing.6">
        <Alert
          icon={InfoIcon}
          color="information"
          emphasis="subtle"
          isDismissible={false}
          description={
            <Text size="small" weight="regular" color="surface.text.gray.muted">
              Are you sure you want to opt out of Voluntary
              Provident Fund (VPF) contributions?
              <br />
              <br />
              This will stop any additional PF savings beyond the mandatory amount.
            </Text>
          }
        />
      </ModalBody>
      <ModalFooter>
        <Box display="flex" flexDirection="row" gap="spacing.5" justifyContent="flex-end">
          <Button variant="tertiary" size="medium" onClick={onDismiss}>
            Cancel
          </Button>
          <Button variant="primary" size="medium" color="negative" onClick={handleOptOut}>
            Opt out
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};

export default VPFOptOutModal;
